import { Workplace } from '../types/workplace';
import { WorkplacePoliciesEnum } from '../types/workplace-policies.enum';

export class WorkplacePolicyUtils {
  public static hasStrict(workplaces: Workplace[] | null): boolean {
    return (workplaces ?? []).some(
      workplace => workplace.checkModPolicy === WorkplacePoliciesEnum.STRICT
    );
  }
}
